import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import whatsappService from '@/services/api/whatsapp.service';
import { WHATSAPP_UNREAD_QUERY_KEY } from './useWhatsAppUnread';
import { WHATSAPP_AGENT_RUNNING_QUERY_KEY } from './useWhatsAppAgentRunning';
import { isHidden } from '@/utils/pageActivity';

// Mounted once in AppRoutes. Phone icons only subscribe to these cached maps;
// mounting 50 icons must not create 50 independent polling timers.
export const useWhatsAppBadgeFeeds = ({ enabled }) => {
  const [visible, setVisible] = useState(() => !isHidden());
  useEffect(() => {
    const update = () => setVisible(!isHidden());
    document.addEventListener('visibilitychange', update);
    return () => document.removeEventListener('visibilitychange', update);
  }, []);

  useQuery({
    queryKey: WHATSAPP_UNREAD_QUERY_KEY,
    queryFn: () => whatsappService.getUnreadByPhone(),
    enabled: enabled && visible,
    staleTime: 15 * 1000,
    refetchInterval: 60 * 1000,
    refetchOnWindowFocus: true,
    retry: 1,
  });
  useQuery({
    queryKey: WHATSAPP_AGENT_RUNNING_QUERY_KEY,
    queryFn: () => whatsappService.getAgentRunning(),
    enabled: enabled && visible,
    staleTime: 5 * 1000,
    refetchInterval: (query) => (query.state.data?.conversation_ids?.length ? 5000 : 30000),
    refetchOnWindowFocus: true,
    retry: 1,
  });
};
